import { render, staticRenderFns } from "./SichernConnectNoEmailBody.vue?vue&type=template&id=7771cf8a&scoped=true"
import script from "./SichernConnectNoEmailBody.vue?vue&type=script&lang=js"
export * from "./SichernConnectNoEmailBody.vue?vue&type=script&lang=js"
import style0 from "./SichernConnectNoEmailBody.vue?vue&type=style&index=0&id=7771cf8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7771cf8a",
  null
  
)

export default component.exports